<template>
  <div
    v-if="attachmentTypeIdForDiagnosisAudio"
    class="section-editor__container section-diagnosis h-100"
  >
    <description-editor
      ref="diagnosisEditor"
      :description-title="$t('diagnosis.sections.diagnosis')"
      :description-service="caseComprehensiveDiagnosisServices"
      :parent-entity-ids-array="[labId, casId]"
      :laboratory-id="labId"
      :case-id="casId"
      :attachment-type-id-for-description-audio="attachmentTypeIdForDiagnosisAudio"
      :attachment-service-for-audio-attachments="caseAttachmentService"
      :root-filename-for-audio-description="`${casId}-DiagnosisAudio-`"
      :attachment-service="attachmentService"
      :disabled="disabled"
      :hide-edit-operations="!$_canEditCase()"
      :hide-attach-operations="!$_canAttachDocumentToCase()"
      :disable-attach-operations="!$_canBeDocumentAttachedToCase(caseData)"
      modal-confirmation-state-store="diagnoseModalsState"
      modal-confirmation-state-name="diagnoseIntegralDiagnoseModalsState"
      modal-confirmation-state-ui-component-code="uicomponent.diagnosis.modalconfig"
    />
    <div class="d-flex justify-content-end">
      <vt-loading-button
        v-if="$_canEditCase()"
        :disabled="disabled"
        class="btn__outline btn-sm mt-2"
        qa="case-diagnosis-save-button"
        :params="{ promise: save, shortkeys: ['alt', 's'] }"
      >
        <i
          class="fal fa-save mr-2"
          aria-hidden="true"
        />
        {{ $t('global.save') }}
      </vt-loading-button>
    </div>
  </div>
</template>

<script>
import DescriptionEditor from '@/components/description/DescriptionEditor'
import attachmentTypeService, { ATTACHMENT_TYPES } from '@/api/resources/attachment/attachmentTypeService'
import caseAttachmentService from '@/api/resources/attachment/caseAttachmentService'
import caseComprehensiveDiagnosisServices from '@/api/resources/cases/caseComprehensiveDiagnosisServices'
import caseComprehensiveDiagnosisAttachmentService from '@/api/resources/description/attachment/caseComprehensiveDiagnosisAttachmentService'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'

export default {
    name: 'CaseDiagnosis',
    components: {
        DescriptionEditor
    },
    mixins: [
        CaseOperationGuardMixin
    ],
    props: {
        labId: { type: Number, required: true },
        caseData: { type: Object, required: true },
        disabled: { type: Boolean, required: true }
    },
    data() {
        return {
            attachmentTypeIdForDiagnosisAudio: null
        }
    },
    computed: {
        casId() {
            return this.caseData?.casId
        },
        caseComprehensiveDiagnosisServices() {
            return caseComprehensiveDiagnosisServices
        },
        caseAttachmentService() {
            return caseAttachmentService
        },
        attachmentService() {
            return caseComprehensiveDiagnosisAttachmentService
        }
    },
    created() {
        this.loadAttachmentTypeIdForDiagnosisAudio()
    },
    methods: {
        hasBeenChanged() {
            return this.$refs.diagnosisEditor.hasBeenChanged()
        },
        async loadAttachmentTypeIdForDiagnosisAudio() {
            this.updateLoading(true)
            const [error, response] = await this.toCall(attachmentTypeService.getAttachmentType('CASE', ATTACHMENT_TYPES.COMPREHENSIVE_DIAGNOSIS_AUDIO))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobal()
                return
            }
            this.attachmentTypeIdForDiagnosisAudio = response.atyId
        },
        async save() {
            const isDiagnosisSavedSuccessfully = await this.$refs.diagnosisEditor.save()
            this.$emit('reloadSummary')
            return isDiagnosisSavedSuccessfully
        }
    }
}
</script>

<style lang="scss">
.section-diagnosis .ql-toolbar.ql-snow {
  padding: 2px;
}

.section-diagnosis .ql-editor {
  transition: 0.35s;
  overflow-y: auto;
}

/*--Styles for large screen--*/
@media (max-width: 1300px) {
  .section-diagnosis .static-audio-col .ar-icon {
    width: 25px;
    height: 25px;
  }

  .section-diagnosis .audio-box .btn {
    font-size: font-size(normal);
  }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .section-diagnosis .ql-editor {
    transition: 0.35s;
    overflow-y: auto;
  }
}
</style>

<style lang="scss" scoped>
.static-audio-col {
  flex: 0 0 350px !important;
}

.audio-scroll {
  min-height: calc(100vh - 930px);
  max-height: calc(100vh - 460px);
  overflow-y: auto;
  transition: 0.35s;
}

@media (max-width: 1370px) {
  .audio-scroll {
    min-height: calc(100vh - 915px);
    max-height: calc(100vh - 450px);
    overflow-y: auto;
    transition: 0.35s;
  }

  .static-audio-col {
    flex: 0 0 250px !important;
  }

  .audio-click span {
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: font-size(small);
  }
}

/*--Sizes for laptop screen--*/
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .audio-scroll {
    min-height: calc(100vh - 620px);
    max-height: calc(100vh - 470px);
    overflow-y: auto;
    transition: 0.35s;
  }

  .static-audio-col {
    flex: 0 0 250px !important;
  }
}
</style>
